module.exports = __webpack_public_path__ + "img/scene-pioneer.6dffae1c.svg";